<template>
  <div class="content">
    <h3>Chaves Externas </h3>
    <div class="line">
      <!-- {{$store.state.company}} -->
      FacebookPixel: <br/><input type="text" class="inputWire" v-model="$store.state.company.facebookPixel" />
      <br/><br/>
      GoogleTagManager: <br/><input type="text"  class="inputWire" v-model="$store.state.company.googleKeys.googleKeyTagManager" />
      <br/><br/>
      GoogleAnalytics: <br/><input type="text" class="inputWire" v-model="$store.state.company.googleKeys.googleKeyAnalytics" />
      <br/><br/>
      OneSignalKey: <br/><input type="text" class="inputWire" v-model="$store.state.company.onSignalKeys.appId" />
      <br/><br/>
      Konduto Chave Privada: <br/><input  type="text" class="inputWire" v-model="$store.state.company.konduto.private_key" />
      <br/><br/>
      Konduto Chave Publica: <br/><input type="text" class="inputWire" v-model="$store.state.company.konduto.public_key" />
      <br/><br/>
      <br/><br/>
      <button @click="saveKeys()">Salvar</button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { EventBus } from '@/utils/event-bus'
import axios from 'axios'
export default {

  created() {
    console.log(this.$store.state.company.konduto)
    if (!this.$store.state.company.konduto) {
      this.$store.state.company.konduto = {}
    }
    if(!this.$store.state.company.googleKeys) {
      this.$store.state.company.googleKeys = {}
    }
  },

  computed: {
    ...mapGetters([ 'getOpaApi' ]),
  },
  methods: {

    async saveKeys () {
      try {
        EventBus.$emit('showLoading', true)
        let konduto = this.$store.state.company.konduto.private_key && this.$store.state.company.konduto.public_key !== '' ? this.$store.state.company.konduto : {}
        let body =  {
          facebookPixel: this.$store.state.company.facebookPixel,
          googleKeys: {
            googleKeyTagManager: this.$store.state.company.googleKeys.googleKeyTagManager,
            googleKeyAnalytics: this.$store.state.company.googleKeys.googleKeyAnalytics
          },
          onSignalKeys:{
            appId: this.$store.state.company.onSignalKeys.appId
          },
          konduto: konduto
        }
        console.log(body)
        let company = await axios.patch(this.getOpaApi +'/company/' + this.$store.state.company.Id, body)
        console.log("asdasd")
        console.log(company.data)
        this.$store.commit('setCompany', company.data)
        EventBus.$emit('showLoading', false)
        EventBus.$emit('showAlert', 'success', 'chaves atualizadas')
      } catch(e) {
        let error = {e}
        console.log(error)
        EventBus.$emit('showAlert', 'error', 'erro ao atualizar chaves')
        EventBus.$emit('showLoading', false)
      }
    }
  }
}
</script>

<style>

</style>
